"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutlinedQuestionIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var colour_1 = require("../theme/colour");
var size_1 = require("../theme/size");
function OutlinedQuestionIcon(_a) {
    var _b = _a.colour, colour = _b === void 0 ? colour_1.colours.grey[90] : _b, _c = _a.size, size = _c === void 0 ? size_1.IconSize.NORMAL : _c;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: size, height: size, viewBox: "0 0 25 25", fill: "none" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M11.9863 18.3492H13.9863V16.3174H11.9863V18.3492ZM12.9863 2.09521C7.46633 2.09521 2.98633 6.64633 2.98633 12.2539C2.98633 17.8616 7.46633 22.4127 12.9863 22.4127C18.5063 22.4127 22.9863 17.8616 22.9863 12.2539C22.9863 6.64633 18.5063 2.09521 12.9863 2.09521ZM12.9863 20.3809C8.57633 20.3809 4.98633 16.7339 4.98633 12.2539C4.98633 7.77395 8.57633 4.12696 12.9863 4.12696C17.3963 4.12696 20.9863 7.77395 20.9863 12.2539C20.9863 16.7339 17.3963 20.3809 12.9863 20.3809ZM12.9863 6.15871C10.7763 6.15871 8.98633 7.97712 8.98633 10.2222H10.9863C10.9863 9.10474 11.8863 8.19045 12.9863 8.19045C14.0863 8.19045 14.9863 9.10474 14.9863 10.2222C14.9863 12.2539 11.9863 12 11.9863 15.3016H13.9863C13.9863 13.0159 16.9863 12.7619 16.9863 10.2222C16.9863 7.97712 15.1963 6.15871 12.9863 6.15871Z", fill: colour }) })));
}
exports.OutlinedQuestionIcon = OutlinedQuestionIcon;
